import React from 'react';
import { CutoffTimes, CutoffTimesData } from '../../../modules/control-tower/api';
import { Table, TableBody, TableCaption, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';

const Cutoff = ({ type, d }: { type: string; d: CutoffTimes }) => {
  return (
    <>
      <div>
        {d[`${type}CutoffHours`].toString().padStart(2, '0')}:{d[`${type}CutoffMinutes`].toString().padStart(2, '0')}
      </div>
      <div>{Math.abs(d[`${type}DaysDiff`]) || 'same'} day</div>
    </>
  );
};

export const CutoffData = ({ data }: { data: CutoffTimesData }) => {
  return (
    <div className="rounded-md border ">
      <div className="top-0 h-[30vh] relative w-full overflow-auto">
        <Table>
          {/* <TableCaption>Cutoff times</TableCaption> */}
          <TableHeader className="sticky top-0 bg-secondary">
            <TableRow>
              <TableHead className="w-[100px]">Location ID</TableHead>
              <TableHead className="w-[120px]">Location Name</TableHead>
              <TableHead className="w-[120px]">Delivery Area</TableHead>
              <TableHead className="w-[150px]">Sorted</TableHead>
              <TableHead className="w-[150px]">In Transit</TableHead>
              <TableHead className="w-[150px]">Out For Delivery</TableHead>
              <TableHead className="w-[150px]">Completed</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((d) => (
              <TableRow key={`${d.locationId}-${d.deliveryAreaName}`}>
                <TableCell className="font-medium">{d.locationId}</TableCell>
                <TableCell className="font-medium">{d.locationName}</TableCell>
                <TableCell className="font-medium">{d.deliveryAreaName}</TableCell>
                <TableCell>
                  <Cutoff d={d} type="sortedAt" />
                </TableCell>
                <TableCell>
                  <Cutoff d={d} type="firstCarrierScanAt" />
                </TableCell>
                <TableCell>
                  <Cutoff d={d} type="firstOutForDeliveryAt" />
                </TableCell>
                <TableCell>
                  <Cutoff d={d} type="completedAt" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
